import { render, staticRenderFns } from "./ModifyPopup.vue?vue&type=template&id=2c32876a&"
import script from "./ModifyPopup.vue?vue&type=script&lang=ts&"
export * from "./ModifyPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports